// Heading reveal: a bar sweeps across each heading as it enters the viewport, and the heading
// resets (masked again) when it leaves. CSS hides them only under html.d-js, so without JS
// (or with reduced motion) they are visible.
(() => {
  // h > span.d-mask (the bar is its ::after) > span.d-mask__label (the original contents)
  const wrap = (el) => {
    if (el.querySelector(':scope > .d-mask')) return;
    const mask = document.createElement('span');
    const label = document.createElement('span');
    mask.className = 'd-mask';
    label.className = 'd-mask__label';
    label.append(...el.childNodes);
    mask.append(label);
    el.append(mask);
  };

  const init = () => {
    const targets = document.querySelectorAll(
      '.p-post-head h1, .p-page-head h1, .p-notfound h1, .p-latest__title, .p-prose h1, .p-prose h2'
    );
    if (!targets.length) return;
    targets.forEach(wrap);
    window.__dReveal = true; // tells the head failsafe (d-reveal-off) that this script is running
    if (!('IntersectionObserver' in window)) {
      targets.forEach((el) => el.classList.add('is-inview'));
      return;
    }
    const io = new IntersectionObserver((entries) => {
      entries.forEach(({ target, isIntersecting, boundingClientRect }) => {
        target.classList.toggle('is-inview', isIntersecting);
        // left through the top: next time it comes back down from above (the bar sweeps the other way)
        if (!isIntersecting) target.classList.toggle('is-above', boundingClientRect.top < 0);
      });
    }, { rootMargin: '-8% 0px -8% 0px' });
    targets.forEach((el) => io.observe(el));
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
